import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const EposShowcase = () => {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image - Left */}
          <div className="flex items-center justify-center">
            <img
              src="https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/7r4ljdd4_EPOS%20%26%20EPOS%20MINI.png"
              alt="eCOMM EPOS & EPOS Mini"
              className="w-full max-w-5xl h-auto scale-[1.35]"
            />
          </div>

          {/* Text - Right */}
          <div>
            <p className="text-[11px] font-bold text-[#0a1929] uppercase tracking-[0.22em] mb-3" data-testid="epos-kicker">
              All-in-One Ordering & Payments
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-bold text-gray-900 mb-4 leading-tight tracking-tight">
              eCOMM EPOS & EPOS Mini
            </h2>
            <p className="text-base sm:text-lg text-gray-600 font-medium tracking-wide uppercase mb-8 leading-relaxed">
              Compact. Powerful. Built for hospitality.
            </p>
            <Button
              asChild
              size="lg"
              className="bg-[#1F4E79] hover:bg-[#163a5f] text-white text-lg px-8 py-6 transition-all duration-200"
              data-testid="discover-our-epos-btn"
            >
              <Link to="/products/epos-and-mini" state={{ from: '/' }}>Discover our EPOS</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EposShowcase;
